// extracted by mini-css-extract-plugin
export var arrows = "_35-6";
export var decrementer = "_35-a";
export var disabled = "_35-4";
export var error = "_35-1";
export var hiddenText = "_35-b";
export var incrementer = "_35-9";
export var input = "_35-8";
export var inputWrapper = "_35-0";
export var leadingIcon = "_35-c";
export var readonly = "_35-3";
export var regular = "_35-7";
export var small = "_35-5";
export var warning = "_35-2";